<template>
  <div>
    <label v-if="label" class="block text-gray-400 mb-2" :for="id">{{ label }}<span v-if="required" class="text-red-500">*</span>:</label>
    <input :id="id" ref="input" v-bind="$attrs" class="text-input" :class="{ 'border-red-400': dataError }" :type="type" :value="value" @input="$emit('input', $event.target.value)" autocomplete="false" :required="required">
    <div v-if="dataError" class="text-red-500 text-sm mt-2">{{ dataError }}</div>
  </div>
</template>

<script>
  export default {
    inheritAttrs: false,
    props: {
      id: {
        type: String,
        default() {
          return `text-input-${this._uid}`
        },
      },
      type: {
        type: String,
        default: 'text',
      },
      value: null,
      label: String,
      dataError: String,
      required:{
        type: Boolean,
        default: false,
      }
    },
    methods: {
      focus() {
        this.$refs.input.focus()
      },
      select() {
        this.$refs.input.select()
      },
      setSelectionRange(start, end) {
        this.$refs.input.setSelectionRange(start, end)
      },
    },
  }
</script>
